import { useEffect, useRef, useState, useCallback } from 'react';
import { useRive, useViewModel, useViewModelInstance } from '@rive-app/react-canvas';

const RiveAnimationInner = ({ state, onReady }) => {
  const { rive, RiveComponent } = useRive({
    src: '/assets/website/ogiso-01.riv',
    stateMachines: 'State Machine 1',
    autoplay: true,
    autoBind: false,
  });

  const viewModel = useViewModel(rive, 'VM_Display');
  useViewModelInstance(viewModel, {
    name: state,
    rive,
  });

  useEffect(() => {
    if (rive) {
      const timer = setTimeout(onReady, 100);
      return () => clearTimeout(timer);
    }
  }, [rive, onReady]);

  return <RiveComponent style={{ width: '100%', height: '100%' }} />;
};

const RiveAnimationStatic = ({ className = '', state }) => {
  const containerRef = useRef(null);
  const [key, setKey] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(false);
            setKey((k) => k + 1);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  const handleReady = useCallback(() => setVisible(true), []);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        width: '100%',
        height: '100%',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.4s ease-out',
      }}
    >
      <RiveAnimationInner key={key} state={state} onReady={handleReady} />
    </div>
  );
};

export default RiveAnimationStatic;
